export default __webpack_public_path__ + "static/media/penjualan.04a03f25.png";